/** Imports */
import {QueryClient} from '@tanstack/react-query';

/** Create a cache owned by one mounted authentication identity (or one server request). */
export function makeQueryClient() {
    return new QueryClient({
        defaultOptions: {
            queries: {staleTime: 30_000, refetchOnWindowFocus: false},
            mutations: {retry: false},
        },
    });
}

/** Retire an unmounted identity's cache without affecting the next identity's requests. */
export function retireQueryClient(client: QueryClient) {
    const cancellation = client.cancelQueries();
    client.clear();
    return cancellation;
}
